import { Add, ViewList } from "@mui/icons-material";
import { Box } from "@mui/material";
import { PrpNavigation } from "./PrpNavigation";
import { PrpNavigationItem } from ".";
import { PrpNavigationItemHome } from "./PrpNavigationItemHome";

export const LiteRaveNavigation = () => {
  const navigationItems = [
    {
      position: 1,
      path: "/lite-raves/create",
      label: "Create",
      icon: <Add />,
      tabProps: {
        "data-cypress": "lite-rave-navigation-create",
      },
      bottomNavigationActionProps: {
        "data-cypress": "lite-rave-navigation-create",
      },
    },
    {
      position: 2,
      path: "/lite-raves/my-raves",
      label: "My Raves",
      icon: <ViewList />,
      tabProps: {
        "data-cypress": "lite-rave-navigation-my-raves",
      },
      bottomNavigationActionProps: {
        "data-cypress": "lite-rave-navigation-my-raves",
      },
    },
  ];

  return (
    <Box
      data-cypress="lite-rave-navigation-container"
      sx={{
        "& .MuiTabs-flexContainer": {
          width: "100vw",
        },
        "& .MuiTab-root": {
          flexGrow: 0,
          flexBasis: "105px",
        },
      }}
    >
      <PrpNavigation>
        <PrpNavigationItemHome />
        {navigationItems.map((item) => (
          <PrpNavigationItem
            key={item.path}
            item={{
              position: item.position,
              path: item.path,
              label: item.label,
              icon: item.icon,
            }}
            tabProps={item.tabProps as any}
            bottomNavigationActionProps={
              item.bottomNavigationActionProps as any
            }
          />
        ))}
      </PrpNavigation>
    </Box>
  );
};
